import { render, staticRenderFns } from "./bank-tab.vue?vue&type=template&id=4cb7ebc8"
import script from "./bank-tab.vue?vue&type=script&lang=js"
export * from "./bank-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports